import { SxProps } from "@mui/material";

export const PanelWrapper: SxProps = {
  backgroundColor: "#ffffff",
  width: "300px",
  borderRight: "1px solid",
  borderColor: "divider",
  height: "100%",
  p: 2,
};

export const containerStyles: SxProps = {
  bgcolor: "#ffffff",
  width: "420px",
  height: "100%",
  overflow: "auto",
};

export const cardStyles: SxProps = {
  // border: "8px solid black",
  width: "330px",
  height: "640px",
  borderRadius: "32px",
  bgcolor: "#F2F5F9",
  py: 2,
  px: 1,
};

export const summaryPanelStyles: SxProps = {
  bgcolor: "white",
  p: 1,
  borderRadius: "12px",
  mt: 1,
};

export const daySelectionItemStyles: SxProps = {
  bgcolor: "white",
  p: 0.8,
  border: "1px solid #e0e3eb",
  borderRadius: "12px",
  minWidth: "fit-content",
};

export const selectedDayStyles: SxProps = {
  ...daySelectionItemStyles,
  border: "3px solid #ff4713",
};

export const toDoCardStyles: SxProps = {
  bgcolor: "white",
  p: 1,
  borderRadius: "12px",
  gap: 1.5,
  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
};

export const appOptionsStyles: SxProps = {
  px: 2,
  py: 2,
  bgcolor: "white",
  borderRadius: "0 0 28px 28px",
  height: "72px",
  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
  justifyContent: "space-around",
  alignItems: "flex-start",
};

export const scanButtonWrapperStyles: SxProps = {
  bgcolor: "white",
  borderRadius: "50%",
  width: "54px",
  height: "54px",
  zIndex: 1000,
  position: "relative",
  bottom: "22px",
  justifyContent: "center",
  alignItems: "center",
};

export const scanButtonInnerStyles: SxProps = {
  p: 0.8,
  borderRadius: "50%",
  width: "48px",
  height: "48px",
  bgcolor: "#fff5f2",
  alignItems: "center",
};

export const uploadWrapper: SxProps = {
  width: "58px",
  height: "48px",
  borderRadius: "8px",
  border: 2,
  borderColor: "primary.main",
  borderStyle: "dashed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  py: 2,
  px: 4,
  "&:hover": {
    bgcolor: "secondary.dark",
    cursor: "pointer",
  },
};

export const splashUploadWrapper: SxProps = {
  width: "200px",
  height: "140px",
  borderRadius: "8px",
  border: 2,
  borderColor: "primary.main",
  borderStyle: "dashed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  py: 2,
  px: 4,
  "&:hover": {
    bgcolor: "secondary.dark",
    cursor: "pointer",
  },
};
